import { kea } from 'kea'
import PropTypes from 'prop-types'

import profilePhotoLogic from '~/scenes/layout/logic'

import controller from './controller.rb'

export default kea({
  initScene: {
    scene: 'courseShow',

    transform: payload => ({
      helmet: payload.helmet,
      course: payload.course,
      timezone: payload.timezone,
      user: payload.user,
      video: payload.video,
      facebookApp: payload.facebookApp,
      needEmail: payload.needEmail,
      contactRedirect: payload.contactRedirect
    })
  },

  path: () => ['scenes', 'courseShow', 'index'],

  dimensions: {
    windowWidth: [typeof window !== 'undefined' && window.innerWidth, window => window.innerWidth]
  },

  connect: {
    props: [profilePhotoLogic, ['avatar']]
  },

  actions: () => ({
    translate: locale => ({ locale }),
    gotTranslation: course => ({ course }),
    translateCourseAndProfile: locale => ({ locale }),
    translateReview: (reviewId, locale) => ({ reviewId, locale }),
    loadMore: true,
    gotMoreReviews: ({ reviews }) => ({ reviews }),
    gotReviewTranslation: review => ({ review }),
    setHoverLocation: location => ({ location }),
    updateCourseAvailability: (availabilityInStudio, availabilityInHouse) => ({
      availabilityInStudio,
      availabilityInHouse
    }),
    updateAvailabilityTimezone: timezone => ({ timezone }),
    enableSharing: true,
    disableSharing: true,
    enablePriceModal: true,
    disablePriceModal: true,
    enableGoodFitModal: true,
    disableGoodFitModal: true,
    enableReviewModal: true,
    disableReviewModal: true,
    openModal: true
  }),

  reducers: ({ actions }) => ({
    helmet: [{}, PropTypes.object, {}],
    needEmail: [false, PropTypes.bool, {}],
    contactRedirect: ['', PropTypes.string, {}],
    isOpenModal: [
      false,
      PropTypes.bool,
      {
        [actions.openModal]: (state, _) => !state
      }
    ],
    isShareModalOpen: [
      false,
      PropTypes.bool,
      {
        [actions.enableSharing]: () => true,
        [actions.disableSharing]: () => false
      }
    ],
    isPriceModalOpen: [
      false,
      PropTypes.bool,
      {
        [actions.enablePriceModal]: () => true,
        [actions.disablePriceModal]: () => false
      }
    ],
    isGoodFitModalOpen: [
      false,
      PropTypes.bool,
      {
        [actions.enableGoodFitModal]: () => true,
        [actions.disableGoodFitModal]: () => false
      }
    ],
    isReviewModalOpen: [
      false,
      PropTypes.bool,
      {
        [actions.enableReviewModal]: () => true,
        [actions.disableReviewModal]: () => false
      }
    ],

    course: [
      null,
      PropTypes.object,
      {
        [actions.gotMoreReviews]: (state, { reviews }) => {
          return {
            ...state,
            reviews: {
              ...state.reviews,
              reviews: [...state.reviews.reviews, ...reviews]
            }
          }
        },
        [actions.gotTranslation]: (state, { course }) => {
          const { reviews } = state
          return { ...course, reviews }
        },
        [actions.updateCourseAvailability]: (state, { availabilityInStudio, availabilityInHouse }) => {
          return { ...state, availabilityInStudio, availabilityInHouse }
        },
        [actions.gotReviewTranslation]: (state, { review }) => {
          const updatedReviews = state.reviews.reviews.map(stateReview =>
            stateReview.id === review.id ? review : stateReview
          )
          const reviews = { ...state.reviews, reviews: updatedReviews }

          return { ...state, reviews }
        }
      }
    ],
    timezone: [
      '',
      PropTypes.string,
      {
        [actions.updateAvailabilityTimezone]: (_, { timezone }) => timezone
      }
    ],
    user: [null, PropTypes.object, {}],

    translating: [
      false,
      PropTypes.bool,
      {
        [actions.translate]: () => true,
        [actions.translateCourseAndProfile]: () => true,
        [actions.translateReview]: () => true,
        [actions.gotTranslation]: () => false,
        [actions.gotReviewTranslation]: () => false
      }
    ],

    hoverLocation: [
      0,
      PropTypes.number,
      {
        [actions.setHoverLocation]: (_, { location }) => location
      }
    ],
    isLoading: [
      false,
      PropTypes.bool,
      {
        [actions.loadMore]: () => true,
        [actions.gotMoreReviews]: () => false
      }
    ],
    video: [null, {}],
    facebookApp: ['', PropTypes.string, {}]
  }),

  selectors: ({ selectors }) => ({
    isMobile: [() => [selectors.windowWidth], windowWidth => windowWidth < 600],
    isTablet: [() => [selectors.windowWidth], windowWidth => windowWidth >= 600 && windowWidth < 1008],
    isTabletUntilInBetween: [() => [selectors.windowWidth], windowWidth => windowWidth >= 600 && windowWidth < 950],
    isDesktopWithInBetween: [() => [selectors.windowWidth], windowWidth => windowWidth >= 950],
    isDesktop: [() => [selectors.windowWidth], windowWidth => windowWidth >= 1008],
    userData: [
      () => [selectors.user, selectors.avatar],
      (user, avatar) => {
        return avatar ? { ...user, avatarUrl: avatar } : user
      },
      PropTypes.object
    ]
  }),

  listeners: ({ actions, values }) => ({
    [actions.loadMore]: async function () {
      const { gotMoreReviews } = actions
      const { id } = values.user
      const response = await controller.loadReviews({ id })
      gotMoreReviews(response)
    }
  })
})
